module.controller('listLimitsCtrl', ['$scope', '$state', '$stateParams', '$http', 'baseURI', 'OVERLAY', function ($scope, $state, $stateParams, $http, baseURI, OVERLAY){
  $scope.overlay = OVERLAY['member.home.limits/list'];
  $scope.allowed = [];
  $scope.disallowed = [];
  $scope.loaded = false;

  $http.get(baseURI + 'card/mcc/restrictions/' + encodeURIComponent($stateParams.username), {cache: true}).then(function (resp){
    $scope.loaded = true;

    var merchants = resp.data.Data;

    if (!merchants) {
      return;
    }

    $scope.allowed = merchants.filter(function(m){ return m.allow; });
    $scope.disallowed = merchants.filter(function(m){ return !m.allow; });
  });
}]);
